// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TUyw","delete":"styles_delete__L4D-y","update":"styles_update__2pvFN","add":"styles_add__1L8GQ"};